import * as React from 'react';
import FormView from 'components/FormView';
import { IInvoiceFields } from '../interfaces';

class InvoiceComponent extends React.PureComponent<IInvoiceFields> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/supplier-invoice-enquiry/invoice-details':
          onInitialLoad('InvoiceDetails');
          break;
        case '/supplier-invoice-enquiry/comments':
          onInitialLoad('Comments');
          break;
        default:
          onInitialLoad('InvoiceDetails');
      }
    }
  }
  getInvoiceLines = () => {
    if (this.props.selectedInvoice) {
      const { Invoice, SalesEntity } = this.props.selectedInvoice;
      this.props.fetchInvoiceLines({ Invoice, SalesEntity });
    }
  }

  getInitialValues = () => {
    const {
      selectedTab, selectedInvoice, invoiceDetails, invoiceComment
    } = this.props;
    switch (selectedTab) {
      case 'InvoiceDetails':
        return selectedInvoice && invoiceDetails && invoiceDetails.inlineObject;
      case 'Comments':
        return selectedInvoice && invoiceComment;
      default:
        return selectedInvoice && invoiceDetails && invoiceDetails.inlineObject;
    }
  }
  getValuesSchema = () => {
    const { selectedTab, invoiceDetails } = this.props;
    switch (selectedTab) {
      case 'InvoiceDetails':
        return invoiceDetails && invoiceDetails.schema;
      default:
        return null;
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode, isLoading, summaryTableRenderer } = this.props;
    const initialValues = this.getInitialValues();
    const valuesSchema = this.getValuesSchema();

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          initialValues={initialValues}
          operationMode={operationMode}
          enableReinitialize={true}
          valuesSchema={valuesSchema}
          summaryTableRenderer={summaryTableRenderer}
        />
      </React.Fragment>
    );
  }
}

export default InvoiceComponent;
